import { useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

export const useHero = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const data = {
    headline: t('home.hero.headline'),
    subtitle: t('home.hero.subtitle'),
    ctaPrimary: t('home.hero.ctaPrimary'),
    ctaSecondary: t('home.hero.ctaSecondary'),
    backgroundImage:
      'https://images.unsplash.com/photo-1758874960180-996bc2523a37?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixlib=rb-4.1.0&q=80&w=1920',
  };

  const handlePrimaryClick = () => {
    navigate({ to: '/form' });
  };

  const handleSecondaryClick = () => {
    const servicesSection = document.getElementById('services');
    if (servicesSection) {
      servicesSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return {
    data,
    handlePrimaryClick,
    handleSecondaryClick,
  };
};

export type HeroProps = ReturnType<typeof useHero>;
